// Teks transaksi Accounting V2 (mis. "ATV 2 SINGLE/MM/OT/GUEST/HOTEL/AGENT/DRIVER"),
// dipakai bersama oleh Accounting V2 dan Pembukuan.
export const getAccountingTypeLabel = (row) => {
  const type = String(row?.type || "").trim();
  if (type) return type.toUpperCase();
  if (Number(row?.net_kuber_nam) > 0 || Number(row?.net_kuber) > 0) return "NAM";
  return "";
};

export const getAccountingTransactionText = (row) => {
  let singleQty = 0;
  let tandemQty = 0;

  row?.activities?.forEach((act) => {
    if (act.activity === "ATV Single") singleQty += act.qty;
    if (act.activity === "ATV Tandem") tandemQty += act.qty;
  });

  const qtyStr = [];
  if (singleQty > 0) qtyStr.push(`${singleQty} SINGLE`);
  if (tandemQty > 0) qtyStr.push(`${tandemQty} TANDEM`);

  const typeLabel = getAccountingTypeLabel(row);
  const typeStr = typeLabel ? `/${typeLabel}` : "";
  const guestTransport = row?.guest_transport ? `/${row.guest_transport.toUpperCase()}` : "";
  const customerName = row?.guest_name ? `/${row.guest_name.toUpperCase()}` : "";
  const hotel = row?.hotel ? `/${row.hotel.toUpperCase()}` : "";
  const agentName = row?.agent_name ? `/${row.agent_name.toUpperCase()}` : "";
  const driverValue = row?.driver_name || row?.driver?.name || row?.driver || row?.reservation?.driver_name || row?.reservation?.driver?.name;
  const driverName = driverValue ? `/${String(driverValue).toUpperCase()}` : "";

  return `ATV ${qtyStr.join(",")}${typeStr}${guestTransport}${customerName}${hotel}${agentName}${driverName}`;
};
